import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf.mjs";
import "./pdfTextLayer.css";

const applyTextLayerScaleVars = (container: HTMLElement, viewport: any) => {
  const scale = String(viewport.scale ?? 1);
  container.style.setProperty("--scale-factor", scale);
  container.style.setProperty("--total-scale-factor", scale);
};

export const renderTextLayer = async (
  container: HTMLDivElement,
  page: any,
  viewport: any,
  textContent?: any
) => {
  container.replaceChildren();
  container.classList.add("textLayer");
  applyTextLayerScaleVars(container, viewport);

  const content = textContent || (await page.getTextContent());

  if (typeof (pdfjsLib as any).setLayerDimensions === "function") {
    (pdfjsLib as any).setLayerDimensions(container, viewport);
  } else {
    container.style.width = `${viewport.width}px`;
    container.style.height = `${viewport.height}px`;
  }

  const textLayer = new pdfjsLib.TextLayer({
    textContentSource: content,
    container,
    viewport
  });
  await textLayer.render();
  return textLayer;
};
